import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ChevronLeftIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M5.83,7.515 L12.133,14.023 L10.696,15.414 L3,7.47 L10.719,0 L12.109,1.437 C12.125,1.38815934 10.032,3.41415934 5.83,7.515 Z"
        data-testid="icon-chevronLeft"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
